<template>
  <a-modal
    v-model="visible"
    title="导入原料"
    width="800px"
    destroyOnClose
    @ok="ok"
    @cancel="cancel"
    @afterClose="cancel"
  >
    <a-table
      row-key="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :row-selection="rowSelection"
      :scroll="{y: 400}"
      bordered
    >
      <template slot="fixed3" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(3) : t }}
      </template>
    </a-table>
  </a-modal>
</template>

  
<script>
export default {
  props: ['visible','ids'],
  data(){
    return {
      selectedRowKeys: [],
      selectedRows: [],
      columns: [
      {
          title: '原料名称',
          dataIndex: 'name',
          width: 150,
          ellipsis: true,
        },
        {
          title: '原料代码',
          dataIndex: 'code',
          width: 120,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          // scopedSlots: {customRender: 'percentage'},
          width: 100,
          ellipsis: true,
        },
        {
          title: '库存量',
          dataIndex: 'storageWeight',
          scopedSlots: {customRender: 'fixed3'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          // scopedSlots: {customRender: 'uasge'},
          width: 80,
          ellipsis: true,
        },
      ],
      list: [],
    }
  },
  watch: {
    visible(val){
      if(val) {
        this.selectedRowKeys = []
        this.selectedRows = []
        this.list = []
        this.getList({current: 1,pageSize: 20})
      }
    }
  },
  computed: {
    rowSelection(){
      return {
        type: 'radio',
        onChange: (selectedRowKeys,selectedRows) => {
          if(selectedRowKeys.length > 0 && this.ids.includes(selectedRowKeys[0])){
            this.selectedRowKeys = []
            this.selectedRows = []
            // this.$message.warning('已添加该原料')
            this.$error({
              title: '操作失败',
              content: `${selectedRows[0].name}已经添加到配方中，请调整后再提交`,
            });
          }else{
            this.selectedRowKeys = selectedRowKeys
            let arr = [...this.selectedRows, ...selectedRows]
            this.selectedRows = selectedRowKeys.map(i => {
              return arr.filter(item=>item.id === i)[0]
            })
          }
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    },
  },
  methods: {
    ok() {
      if(this.selectedRows.length === 0){
        this.$message.warning('请选择原料')
        return
      }
      let obj = this.selectedRows[0] || {}
      let data = {
        ...obj,percentage: '',uasge: '',rawId: obj.id,rawName: obj.name,rawCode: obj.code,unit: 'KG'
      }
      this.$emit('close',data)
    },
    cancel(){
      this.$emit('close')
    },
    getList(){
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/nhf-core-data/raw/getRawListByTagId',{params}).then(res => {
        let {success,data} = res;
        if(success){
          this.list = data || []
        }else{
          this.$message.error('查询失败')
        }
      })
    },
  }
}
</script>